<div class="container bg-light position-relative tournament-page">
    @if (loaded && (data || loadedError)) {
        @if (loadedError) {
            <div class="pb-6">
                <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                    <div class="text-center pt-7">
                        <svg class="icon icon--64 mb-4">
                            <use [attr.xlink:href]="'#icon-' + sportName" />
                        </svg>
                        <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                        <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                    </div>
                </div>
            </div>
        }
        @if (!loadedError) {
            <div class="row bg-white p-0">
                <!-- Col Left -->
                <div class="col-lg-8 bg-white pl-0 pr-0" [ngClass]="parentClass">
                    <div class="pl-5 pt-5 pr-5 pr-lg-0 pb-3">
                        <!--Progress bar + logo-->
                        <div class="row no-gutters">
                            <div class="col-md-8">
                                <div class="media">
                                    <div class="img-team img-team--lg mr-3">
                                        @if (isMobile && data?.tournament_country_iso && sportName === 'tennis') {
                                            <img
                                                src="{{
                                                    cdn +
                                                        '/img/flags/1x1/' +
                                                        (data?.tournament_country_iso | lowercase) +
                                                        '.svg'
                                                }}"
                                                width="68"
                                                class="img-fluid mr-2 rounded-circle"
                                                alt="{{ data?.tournament_country_iso }}"
                                            />
                                        } @else {
                                            <img
                                                [src]="cdn + data?.image"
                                                alt="{{ data?.tournament_name }}"
                                                width="68"
                                                class="img-fluid mr-2"
                                            />
                                        }
                                    </div>
                                    <div class="media-body">
                                        <div class="d-flex icon-wrapper justify-content-start">
                                            <h1 class="text-uppercase mb-2">{{ data?.tournament_name }}</h1>
                                            <div class="break-md"></div>
                                        </div>
                                        <div class="mb-2 h5 d-flex">
                                            <span class="font-weight-bold mr-1"> {{ subTournamentName }}</span>
                                            @if (![170, 497].includes(data?.category_id)) {
                                                <a
                                                    [routerLink]="[
                                                        '/page/sport/category',
                                                        sportName + '-' + sportId,
                                                        data?.category_id,
                                                    ]"
                                                    routerLinkActive="text-danger"
                                                    data-cy="competiton-navigation-item"
                                                    class="text-reset align-self-center"
                                                    >({{ data?.category_name }})</a
                                                >
                                            }
                                        </div>
                                        @if (showSeasonPeriod) {
                                            <div class="col-12 col-sm-9 pt-2 pb-2 pt-md-3 pl-md-1 pr-md-3">
                                                <div class="progress">
                                                    <progress
                                                        [value]="actualSeasonProgress"
                                                        class="livescore-progress-bar"
                                                        max="100"
                                                    >
                                                        {{ actualSeasonProgress }}%
                                                    </progress>
                                                </div>
                                                @if (progress) {
                                                    <div class="row mt-2 small">
                                                        <div class="col">
                                                            {{ progress?.start | livDate: 'localDate' }}
                                                        </div>
                                                        <div class="col text-right">
                                                            {{ progress?.end | livDate: 'localDate' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <!--Tournament name +  filters-->
                            <div class="col-md-4 text-md-right mt-2 mt-md-auto">
                                <div
                                    class="d-flex flex-column-reverse align-items-stretch flex-md-column align-items-end mr-sm-3"
                                >
                                    @if (data?.seasons.length > 1) {
                                        <div class="flex-grow-1">
                                            <select
                                                class="custom-select border-light2 mt-1"
                                                [formControl]="seasonControl"
                                            >
                                                @for (season of reverseSeason; track trackByFnSeason($index, season)) {
                                                    <option [value]="season.season_id">
                                                        {{ season.season_name }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    }
                                    @if (data?.subtournaments.length > 1) {
                                        <div class="flex-grow-1 mt-2">
                                            <select
                                                class="custom-select border-light2"
                                                [formControl]="subTournamentControl"
                                            >
                                                <option [value]="0">{{ 'web.all_subtournaments' | translate }}</option>
                                                @for (
                                                    sub of data?.subtournaments;
                                                    track trackByFnSubtournament($index, sub)
                                                ) {
                                                    <option [value]="sub.sub_tournament_id">
                                                        {{ sub.sub_tournament_name }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--End Tournament name +  filters-->
                    <div class="nav-wrapper app-mob-nav-wrapper app-scrollable-tabs" style="position: relative">
                        <!-- <div class="app-mob-nav-shadow"></div> -->
                        <button
                            class="tabs-scroll-btn tabs-scroll-btn--prev"
                            [class.tabs-scroll-btn--visible]="canScrollLeft"
                            (click)="scrollTabs('left')"
                            aria-label="Scroll tabs left"
                        >
                            <span class="prev"></span>
                        </button>
                        <ul
                            #tabsList
                            class="nav nav-tabs font-weight-bold pt-0"
                            id="tabs-left"
                            role="tablist"
                            scrollEnd
                            (scroll)="onTabsScroll()"
                        >
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-4 active"
                                    [class.active]="activeTab == 1"
                                    id="tab1"
                                    data-toggle="tab"
                                    href="#overview"
                                    [routerLink]="['.']"
                                    fragment="overview"
                                    role="tab"
                                    (click)="activeTabFce(1)"
                                    aria-controls="tab1-content"
                                    aria-selected="true"
                                    >{{ 'web.overview' | translate | transinit }}</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-4"
                                    [class.active]="activeTab == 2"
                                    id="tab2"
                                    data-toggle="tab"
                                    href="#results"
                                    [routerLink]="['./']"
                                    fragment="results"
                                    role="tab"
                                    (click)="activeTabFce(2)"
                                    aria-controls="tab2-content"
                                    aria-selected="false"
                                    >{{ 'web.finished_matches' | renamesportnav: sportName | translate | transinit }}</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link px-3 px-md-4"
                                    [class.active]="activeTab == 3"
                                    id="tab3"
                                    data-toggle="tab"
                                    href="#future"
                                    [routerLink]="['./']"
                                    fragment="future"
                                    role="tab"
                                    (click)="activeTabFce(3)"
                                    aria-controls="tab3-content"
                                    aria-selected="false"
                                    >{{ 'web.future_matches' | renamesportnav: sportName | translate | transinit }}</a
                                >
                            </li>
                            @if (data?.hasTable) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 4"
                                        id="tab4"
                                        data-toggle="tab"
                                        href="#table"
                                        role="tab"
                                        [routerLink]="['./']"
                                        fragment="table"
                                        (click)="activeTabFce(4)"
                                        aria-controls="tab4-content"
                                        aria-selected="false"
                                        >{{ 'web.league_table' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.hasCupTree) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4 app-cursor"
                                        [class.active]="activeTab == 5"
                                        id="tab5"
                                        data-toggle="tab"
                                        (click)="activeTabFce(5); openCupTree()"
                                        role="tab"
                                        aria-controls="tab5-content"
                                        aria-selected="false"
                                        >{{ 'web.cup_tree' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.hasPlayerStats && selectedSubtournament !== 0) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 6"
                                        id="tab6"
                                        data-toggle="tab"
                                        href="#player-stats"
                                        [routerLink]="['./']"
                                        fragment="player-stats"
                                        role="tab"
                                        (click)="activeTabFce(6)"
                                        aria-controls="tab6-content"
                                        aria-selected="false"
                                        >{{ 'web.player-statistics' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.players_transfers && (data?.players_transfers)!.length > 0 && displayTransfers) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 7"
                                        id="tab7"
                                        data-toggle="tab"
                                        href="#players-transfers"
                                        [routerLink]="['./']"
                                        fragment="players-transfers"
                                        role="tab"
                                        (click)="activeTabFce(7)"
                                        aria-controls="tab7-content"
                                        aria-selected="false"
                                        >{{ 'web.players-transfers' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.season_info && isMobile) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 8"
                                        id="tab8"
                                        data-toggle="tab"
                                        href="#tennis-tournament-info"
                                        [routerLink]="['./']"
                                        fragment="tennis-tournament-info"
                                        role="tab"
                                        (click)="activeTabFce(8)"
                                        aria-controls="tab8-content"
                                        aria-selected="false"
                                        >{{ 'web.tennis_tournament_info' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.hasInjuries) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 9"
                                        id="tab9"
                                        data-toggle="tab"
                                        href="#injuries"
                                        role="tab"
                                        [routerLink]="['./']"
                                        fragment="injuries"
                                        (click)="activeTabFce(9)"
                                        aria-controls="tab9-content"
                                        aria-selected="false"
                                        >{{ 'web.injuries' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.has_drafts) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 10"
                                        id="tab10"
                                        data-toggle="tab"
                                        href="#drafts"
                                        role="tab"
                                        [routerLink]="['./']"
                                        fragment="drafts"
                                        (click)="activeTabFce(10)"
                                        aria-controls="tab10-content"
                                        aria-selected="false"
                                        >{{ 'web.drafts' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.has_free_agents) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 11"
                                        id="tab11"
                                        data-toggle="tab"
                                        href="#free-agents"
                                        role="tab"
                                        [routerLink]="['./']"
                                        fragment="free-agents"
                                        (click)="activeTabFce(11)"
                                        aria-controls="tab11-content"
                                        aria-selected="false"
                                        >{{ 'web.free-agents' | translate | transinit }}</a
                                    >
                                </li>
                            }
                            @if (data?.has_awards) {
                                <li class="nav-item">
                                    <a
                                        class="nav-link px-3 px-md-4"
                                        [class.active]="activeTab == 12"
                                        id="tab11"
                                        data-toggle="tab"
                                        href="#awards"
                                        role="tab"
                                        [routerLink]="['./']"
                                        fragment="awards"
                                        (click)="activeTabFce(12)"
                                        aria-controls="tab12-content"
                                        aria-selected="false"
                                        >{{ 'web.awards' | translate | transinit }}</a
                                    >
                                </li>
                            }
                        </ul>
                        <button
                            class="tabs-scroll-btn tabs-scroll-btn--next"
                            [class.tabs-scroll-btn--visible]="canScrollRight"
                            (click)="scrollTabs('right')"
                            aria-label="Scroll tabs right"
                        >
                            <span class="next"></span>
                        </button>
                    </div>
                    <div class="tab-content bg-white px-0 px-lg-3 py-3 position-relative">
                        @if (activeTab == 1) {
                            <div
                                class="tab-pane active"
                                [class.active]="activeTab == 1"
                                id="overview"
                                role="tabpanel"
                                aria-labelledby="tab1"
                            >
                                @if (isMobile && hasOptaStats) {
                                    <app-auth-container
                                        [authOff]="!client.use('signin')"
                                        permission="premium_stats"
                                        [extraPermission]="[
                                            'american_sports',
                                            'tracker',
                                            'stream',
                                            'betting_widgets',
                                            'stats',
                                            'all',
                                        ]"
                                    >
                                        @defer (on viewport) {
                                            <app-opta-competition-stats
                                                [competitionId]="data?.opta_competition"
                                                [seasonId]="data?.opta_season"
                                            ></app-opta-competition-stats>
                                        } @placeholder { <div></div> }
                                        @defer (on viewport) {
                                            <app-opta-team-ranking
                                                [competitionId]="data?.opta_competition"
                                                [seasonId]="data?.opta_season"
                                            ></app-opta-team-ranking>
                                        } @placeholder { <div></div> }
                                    </app-auth-container>
                                }
                                <!--Live matches-->
                                @if (data?.data?.live && data?.data?.live.length > 0) {
                                    <h6
                                        class="table-sport__head bg-dark bg-primary--light"
                                        data-toggle="collapse"
                                        data-target="#collapse-live"
                                        role="button"
                                        aria-expanded="true"
                                        aria-controls="collapse-today"
                                    >
                                        <span class="table-sport__head__text">{{
                                            'web.live_matches' | translate | transinit
                                        }}</span>
                                    </h6>
                                    <div class="collapse show" id="collapse-live">
                                        @for (match of data?.data?.live; track trackById($index, match)) {
                                            <app-component-match
                                                [match]="match"
                                                [sportName]="sportName"
                                                [sportId]="sportId"
                                                page="tournament"
                                                (onSelect)="loadMatch($event)"
                                            ></app-component-match>
                                        }
                                    </div>
                                }
                                <!--End Live matches-->
                                <!--League latest matches-->
                                @if (
                                    (hasNoRounds ||
                                        allMode ||
                                        data?.hasTable ||
                                        (!data?.hasTable && !data?.hasCupTree)) &&
                                    this.data?.data?.finished.length > 0
                                ) {
                                    <h6
                                        class="table-sport__head bg-dark text-white mt-3"
                                        data-toggle="collapse"
                                        data-target="#collapse-last"
                                        role="button"
                                        aria-expanded="true"
                                        aria-controls="collapse-last"
                                    >
                                        <span class="table-sport__head__text">{{
                                            'web.latest_matches' | translate | transinit
                                        }}</span>
                                    </h6>
                                    @if (allMode || this.isNoRoundF) {
                                        <div class="collapse show" id="collapse-last">
                                            @for (
                                                match of this.data?.data?.finished | slice: 0 : 20;
                                                track trackById(i, match);
                                                let i = $index
                                            ) {
                                                @if (
                                                    allMode &&
                                                    (i === 0 ||
                                                        match.sub_tournament_name !==
                                                            this.data?.data?.finished[i - 1].sub_tournament_name)
                                                ) {
                                                    <div
                                                        class="table-sport__subhead d-flex align-items-center bg-light ng-star-inserted"
                                                    >
                                                        <div class="mb-0 text-uppercase text-truncate">
                                                            {{ match.sub_tournament_name }}
                                                        </div>
                                                    </div>
                                                }
                                                <app-component-match
                                                    [dateFormat]="'localDateTimeShort'"
                                                    dateFormat2="localDateShort"
                                                    [match]="match"
                                                    [sportName]="sportName"
                                                    [sportId]="sportId"
                                                    page="tournament"
                                                    (onSelect)="loadMatch($event)"
                                                ></app-component-match>
                                            }
                                        </div>
                                    }
                                    @if (!allMode && !this.isNoRoundF) {
                                        <div class="collapse show" id="collapse-last">
                                            @for (matches of normalizeFinishedByDate; track $index) {
                                                <div
                                                    class="table-sport__subhead d-flex align-items-center bg-light"
                                                    data-toggle="collapse"
                                                    [attr.data-target]="'#collapse-last-' + $index"
                                                    role="button"
                                                    aria-expanded="true"
                                                    aria-controls="collapse-last-1"
                                                >
                                                    <div
                                                        class="table-sport__subhead__text mb-0 text-uppercase text-truncate"
                                                    >
                                                        @if (matches[0]?.round_name != null) {
                                                            {{ matches[0]?.round_name }}
                                                        }
                                                        @if (
                                                            matches[0]?.round_name == null && matches[0]?.round != null
                                                        ) {
                                                            {{ matches[0]?.round }}.
                                                            {{ 'web.round' | translate | transinit }}
                                                        }
                                                    </div>
                                                </div>
                                                <div class="collapse show" id="collapse-last-{{ $index }}">
                                                    @for (match of matches; track trackById($index, match)) {
                                                        <app-component-match
                                                            [dateFormat]="'localDateTimeShort'"
                                                            dateFormat2="localDateShort"
                                                            [match]="match"
                                                            [sportName]="sportName"
                                                            [sportId]="sportId"
                                                            page="tournament"
                                                            (onSelect)="loadMatch($event)"
                                                        ></app-component-match>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    <div class="text-center mt-3 mb-4">
                                        <button class="btn btn-outline-secondary btn-sm px-5" (click)="tab('results')">
                                            {{ 'web.more_results' | translate }}
                                        </button>
                                    </div>
                                }
                                <!--End League latest matches-->
                                <!--League Not started matches-->
                                @if (
                                    (hasNoRounds ||
                                        allMode ||
                                        data?.hasTable ||
                                        (!data?.hasTable && !data?.hasCupTree)) &&
                                    this.data?.data?.not_started.length > 0
                                ) {
                                    <h6
                                        class="table-sport__head bg-dark text-white mt-3"
                                        data-toggle="collapse"
                                        data-target="#collapse-not"
                                        role="button"
                                        aria-expanded="true"
                                        aria-controls="collapse-last"
                                    >
                                        <span class="table-sport__head__text">{{
                                            'web.not_started_matches' | translate | transinit
                                        }}</span>
                                    </h6>
                                    @if (allMode || this.isNoRoundNS) {
                                        <div class="collapse show" id="collapse-not">
                                            @for (
                                                match of this.data?.not_started_r | slice: 0 : 20;
                                                track trackById($index, match)
                                            ) {
                                                @if (allMode) {
                                                    <div
                                                        class="table-sport__subhead d-flex align-items-center bg-light ng-star-inserted"
                                                    >
                                                        <div class="mb-0 text-uppercase text-truncate">
                                                            {{ match.sub_tournament_name }}
                                                        </div>
                                                    </div>
                                                }
                                                <app-component-match
                                                    [dateFormat]="'localDateTimeShort'"
                                                    [match]="match"
                                                    [sportName]="sportName"
                                                    [sportId]="sportId"
                                                    page="tournament"
                                                    (onSelect)="loadMatch($event)"
                                                ></app-component-match>
                                            }
                                        </div>
                                    }
                                    @if (!allMode && !this.isNoRoundNS) {
                                        <div class="collapse show" id="collapse-not">
                                            @for (matches of normalizeNotStartedByDate; track $index) {
                                                <div
                                                    class="table-sport__subhead d-flex align-items-center bg-light"
                                                    data-toggle="collapse"
                                                    [attr.data-target]="'#collapse-not-' + $index"
                                                    role="button"
                                                    aria-expanded="true"
                                                    aria-controls="collapse-last-1"
                                                >
                                                    <div
                                                        class="table-sport__subhead__text mb-0 text-uppercase text-truncate"
                                                    >
                                                        @if (matches[0]?.round_name != null) {
                                                            {{ matches[0]?.round_name }}
                                                        }
                                                        @if (
                                                            matches[0]?.round_name == null && matches[0]?.round != null
                                                        ) {
                                                            {{ matches[0]?.round }}.
                                                            {{ 'web.round' | translate | transinit }}
                                                        }
                                                    </div>
                                                </div>
                                                <div class="collapse show" id="collapse-not-{{ $index }}">
                                                    @for (match of matches; track trackById($index, match)) {
                                                        <app-component-match
                                                            [dateFormat]="'localDateTimeShort'"
                                                            [match]="match"
                                                            [sportName]="sportName"
                                                            [sportId]="sportId"
                                                            page="tournament"
                                                            (onSelect)="loadMatch($event)"
                                                        ></app-component-match>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    <div class="text-center mt-3 mb-4">
                                        <button class="btn btn-outline-secondary btn-sm px-5" (click)="tab('future')">
                                            {{ 'web.more_future' | translate }}
                                        </button>
                                    </div>
                                }
                                <!--End League Not started matches-->
                                <!-- Cup tree data-->
                                <!--Cup tree latest matches-->
                                @if (!allMode && !hasNoRounds && data?.hasCupTree && !data?.hasTable) {
                                    @for (matches of cupTreeOverview; track $index) {
                                        @if (matches[0]?.round_name != null || matches[0]?.round != null) {
                                            <h6
                                                class="table-sport__head bg-dark text-white mt-3"
                                                data-toggle="collapse"
                                                [attr.data-target]="'#collapse-cuptree-' + $index"
                                                role="button"
                                                aria-expanded="true"
                                                aria-controls="collapse-last"
                                            >
                                                @if (matches[0]?.round_name != null) {
                                                    <span class="table-sport__head__text">{{
                                                        matches[0]?.round_name
                                                    }}</span>
                                                }
                                                @if (matches[0]?.round_name == null && matches[0]?.round != null) {
                                                    <span class="table-sport__head__text"
                                                        >{{ matches[0]?.round }}.
                                                        {{ 'web.round' | translate | transinit }}</span
                                                    >
                                                }
                                            </h6>
                                            <div class="collapse show" id="collapse-cuptree-{{ $index }}">
                                                @for (match of matches; track trackById($index, match)) {
                                                    <app-component-match
                                                        [dateFormat]="'localDateTimeShort'"
                                                        dateFormat2="localDateShort"
                                                        [match]="match"
                                                        [sportName]="sportName"
                                                        [sportId]="sportId"
                                                        page="tournament"
                                                        (onSelect)="loadMatch($event)"
                                                    ></app-component-match>
                                                }
                                            </div>
                                        }
                                    }
                                    <div class="text-center mt-3 mb-4">
                                        <button class="btn btn-outline-secondary btn-sm px-5" (click)="tab('results')">
                                            {{ 'web.more_results' | translate }}
                                        </button>
                                    </div>
                                }
                                <!--Cup tree latest matches-->
                            </div>
                        }
                        @if (activeTab == 2) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 2"
                                id="results"
                                role="tabpanel"
                                aria-labelledby="tab1"
                            >
                                <!--Finished matches-->
                                @if (allMode || this.isNoRoundF) {
                                    @for (
                                        match of this.data?.data?.finished | slice: 0 : finishedLimit;
                                        track trackById($index, match)
                                    ) {
                                        <app-component-match
                                            [dateFormat]="'localDateTimeShort'"
                                            dateFormat2="localDateShort"
                                            [match]="match"
                                            [sportName]="sportName"
                                            [sportId]="sportId"
                                            page="tournament"
                                            (onSelect)="loadMatch($event)"
                                        ></app-component-match>
                                    }
                                }
                                @if (!allMode && !this.isNoRoundF) {
                                    @for (matches of normalizeFinished | slice: 0 : finishedLimit; track $index) {
                                        @if (matches[0]?.round_name != null || matches[0]?.round != null) {
                                            <h6
                                                class="table-sport__head bg-dark text-white mt-3"
                                                data-toggle="collapse"
                                                [attr.data-target]="'#collapse-finished-sub-' + $index"
                                                role="button"
                                                aria-expanded="true"
                                                aria-controls="collapse-last"
                                            >
                                                @if (matches[0]?.round_name != null) {
                                                    <span class="table-sport__head__text">{{
                                                        matches[0]?.round_name
                                                    }}</span>
                                                }
                                                @if (matches[0]?.round_name == null && matches[0]?.round != null) {
                                                    <span class="table-sport__head__text"
                                                        >{{ matches[0]?.round }}.
                                                        {{ 'web.round' | translate | transinit }}</span
                                                    >
                                                }
                                            </h6>
                                            <div class="collapse show" id="collapse-finished-sub-{{ $index }}">
                                                @for (match of matches; track trackById($index, match)) {
                                                    <app-component-match
                                                        [dateFormat]="'localDateTimeShort'"
                                                        dateFormat2="localDateShort"
                                                        [match]="match"
                                                        [sportName]="sportName"
                                                        [sportId]="sportId"
                                                        page="tournament"
                                                        (onSelect)="loadMatch($event)"
                                                    ></app-component-match>
                                                }
                                            </div>
                                        }
                                    }
                                }
                                @if (!isDone('finished')) {
                                    <div class="text-center mt-3 mb-4">
                                        <button class="btn btn-outline-secondary btn-sm px-5" (click)="nextResult()">
                                            {{ 'web.next_result' | translate }}
                                        </button>
                                    </div>
                                }
                                @if (this.data?.data?.finished.length == 0) {
                                    <div class="text-center">
                                        <strong>{{ 'web.no_data_found' | translate }}</strong>
                                    </div>
                                }
                                <!--End Finished matches-->
                            </div>
                        }
                        @if (activeTab == 3) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 3"
                                id="future"
                                role="tabpanel"
                                aria-labelledby="tab1"
                            >
                                <!--Future matches-->
                                @if (allMode || this.isNoRoundNS) {
                                    @for (
                                        match of this.data?.not_started_r | slice: 0 : notStartedLimit;
                                        track trackById($index, match)
                                    ) {
                                        <app-component-match
                                            [dateFormat]="'localDateTimeShort'"
                                            [match]="match"
                                            [sportName]="sportName"
                                            [sportId]="sportId"
                                            page="tournament"
                                            (onSelect)="loadMatch($event)"
                                        ></app-component-match>
                                    }
                                }
                                @if (!allMode && !this.isNoRoundNS) {
                                    @for (matches of normalizeNotStarted | slice: 0 : notStartedLimit; track $index) {
                                        @if (matches[0]?.round_name != null || matches[0]?.round != null) {
                                            <h6
                                                class="table-sport__head bg-dark text-white mt-3"
                                                data-toggle="collapse"
                                                [attr.data-target]="'#collapse-not_started-sub-' + $index"
                                                role="button"
                                                aria-expanded="true"
                                                aria-controls="collapse-last"
                                            >
                                                @if (matches[0]?.round_name != null) {
                                                    <span class="table-sport__head__text">{{
                                                        matches[0]?.round_name
                                                    }}</span>
                                                }
                                                @if (matches[0]?.round_name == null && matches[0]?.round != null) {
                                                    <span class="table-sport__head__text"
                                                        >{{ matches[0]?.round }}.
                                                        {{ 'web.round' | translate | transinit }}</span
                                                    >
                                                }
                                            </h6>
                                            <div class="collapse show" id="collapse-not_started-sub-{{ $index }}">
                                                @for (match of matches; track trackById($index, match)) {
                                                    <app-component-match
                                                        [dateFormat]="'localDateTimeShort'"
                                                        [match]="match"
                                                        [sportName]="sportName"
                                                        [sportId]="sportId"
                                                        page="tournament"
                                                        (onSelect)="loadMatch($event)"
                                                    ></app-component-match>
                                                }
                                            </div>
                                        }
                                    }
                                }
                                @if (!isDone('not_started')) {
                                    <div class="text-center mt-3 mb-4">
                                        <button class="btn btn-outline-secondary btn-sm px-5" (click)="nextResult()">
                                            {{ 'web.next_result' | translate }}
                                        </button>
                                    </div>
                                }
                                @if (this.data?.data?.not_started.length == 0) {
                                    <div class="text-center">
                                        <strong>{{ 'web.no_data_found' | translate }}</strong>
                                    </div>
                                }
                                <!--End Future matches-->
                            </div>
                        }
                        @if (activeTab == 4) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 4"
                                id="table"
                                role="tabpanel"
                                aria-labelledby="tab1"
                            >
                                <app-league-table
                                    [sportName]="sportName"
                                    [sportId]="sportId"
                                    [subTournamentId]="data?.sub_tournament_id"
                                    [seasonId]="data?.season_id"
                                ></app-league-table>
                            </div>
                        }
                        @if (activeTab == 6) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 6"
                                id="player-stats"
                                role="tabpanel"
                                aria-labelledby="tab1"
                            >
                                <app-player-stats
                                    [subTournamentId]="data?.sub_tournament_id"
                                    [seasonId]="data?.season_id"
                                    [sportName]="sportName"
                                    [sportId]="sportId"
                                ></app-player-stats>
                            </div>
                        }
                        @if (activeTab == 7) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 7"
                                id="players-transfers"
                                role="tabpanel"
                                aria-labelledby="tab7"
                            >
                                <app-player-transfers
                                    [playerTransfers]="data?.players_transfers"
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                ></app-player-transfers>
                            </div>
                        }
                        @if (activeTab == 8 && isMobile) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 8"
                                id="tennis-tournament-info"
                                role="tabpanel"
                                aria-labelledby="tab8"
                            >
                                @if (seasonInfoData) {
                                    <app-tennis-tournament-info
                                        [tennisTournamentInfo]="seasonInfoData"
                                        [iso]="data?.tournament_country_iso"
                                        [sportId]="sportId"
                                        [sportName]="sportName"
                                    ></app-tennis-tournament-info>
                                }
                            </div>
                        }
                        @if (activeTab == 9) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 9"
                                id="injuries"
                                role="tabpanel"
                                aria-labelledby="tab9"
                            >
                                <app-auth-container
                                    [authOff]="!client.use('signin')"
                                    permission="premium_stats"
                                    [extraPermission]="[
                                        'american_sports',
                                        'tracker',
                                        'stream',
                                        'betting_widgets',
                                        'stats',
                                        'all',
                                    ]"
                                >
                                    @if (hasGroupedInjuries) {
                                        <app-grouped-tournament-injuries
                                            [sportId]="sportId"
                                            [sportName]="sportName"
                                            [subTournamentId]="data?.sub_tournament_id"
                                            [seasonId]="data?.season_id"
                                        >
                                        </app-grouped-tournament-injuries>
                                    }
                                    @if (!hasGroupedInjuries) {
                                        <app-injuries
                                            [sportId]="sportId"
                                            [sportName]="sportName"
                                            [tournamentId]="tournamentId"
                                            [showPracticeStatus]="false"
                                        >
                                        </app-injuries>
                                    }
                                </app-auth-container>
                            </div>
                        }
                        @if (activeTab == 10) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 10"
                                id="drafts"
                                role="tabpanel"
                                aria-labelledby="tab10"
                            >
                                <app-auth-container
                                    [authOff]="!client.use('signin')"
                                    permission="premium_stats"
                                    [extraPermission]="[
                                        'american_sports',
                                        'tracker',
                                        'stream',
                                        'betting_widgets',
                                        'stats',
                                        'all',
                                    ]"
                                >
                                    <app-drafts
                                        [sportId]="sportId"
                                        [sportName]="sportName"
                                        [tournamentId]="data?.tournament_id"
                                    >
                                    </app-drafts>
                                </app-auth-container>
                            </div>
                        }
                        @if (activeTab == 11) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 11"
                                id="free-agents"
                                role="tabpanel"
                                aria-labelledby="tab11"
                            >
                                <app-free-agents
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                    [tournamentId]="data?.tournament_id"
                                >
                                </app-free-agents>
                            </div>
                        }
                        @if (activeTab == 12) {
                            <div
                                class="tab-pane"
                                [class.active]="activeTab == 12"
                                id="awards"
                                role="tabpanel"
                                aria-labelledby="tab11"
                            >
                                <app-awards [sportId]="sportId" [sportName]="sportName" [data]="data"> </app-awards>
                            </div>
                        }
                        @if (client.use('seoCard') && data?.tournament_info) {
                            <div class="card shadow border-0 mt-5">
                                <div class="app-info-card card-body p-0 p-md-5">
                                    <div class="media">
                                        <svg class="icon icon--32 mr-3">
                                            <use href="#icon-bulp-2" />
                                        </svg>
                                        <div class="media-body mt-2">
                                            <h6 class="font-weight-bold text-uppercase">{{ data?.tournament_name }}</h6>
                                            <div [innerHTML]="data?.tournament_info | markdown"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <!-- / Col Left -->
                <!-- Col Right -->
                <div class="col-lg-4 d-none d-lg-block" [ngClass]="matchClass">
                    @if (seasonInfoData) {
                        <app-tennis-tournament-info
                            [tennisTournamentInfo]="seasonInfoData"
                            [iso]="data?.tournament_country_iso"
                            [sportId]="sportId"
                            [sportName]="sportName"
                        ></app-tennis-tournament-info>
                    }
                    @if (hasOptaStats) {
                        <app-auth-container
                            [authOff]="!client.use('signin')"
                            permission="premium_stats"
                            [extraPermission]="[
                                'american_sports',
                                'tracker',
                                'stream',
                                'betting_widgets',
                                'stats',
                                'all',
                            ]"
                        >
                            @defer (on viewport) {
                                <app-opta-competition-stats
                                    [competitionId]="data?.opta_competition"
                                    [seasonId]="data?.opta_season"
                                ></app-opta-competition-stats>
                            } @placeholder { <div></div> }
                            @defer (on viewport) {
                                <app-opta-team-ranking
                                    [competitionId]="data?.opta_competition"
                                    [seasonId]="data?.opta_season"
                                ></app-opta-team-ranking>
                            } @placeholder { <div></div> }
                        </app-auth-container>
                    }
                    <app-switchers (onStickyChange)="onStickyChange($event)"></app-switchers>
                    @if (matchId) {
                        <div
                            [class.sticky-parent]="stickyDetail"
                            class="col-right__inner bg-white"
                            data-cy="right-column-match"
                        >
                            <app-match-detail
                                class="sticky-parent__match"
                                [class.app-match-detail--shadow]="stickyDetail"
                                [style.max-height]="viewPortHeightMatchDetail"
                                [id]="matchId"
                                [matchState]="matchState"
                                [tracker]="tracker"
                                [stream]="stream"
                            ></app-match-detail>
                        </div>
                    }
                    @if (tournamentLink) {
                        <app-tournament-link
                            [sportId]="sportId"
                            [categoryId]="data?.category_id"
                            [tournamentId]="data?.tournament_id"
                            [flag]="data?.image"
                            [name]="data?.category_name"
                        ></app-tournament-link>
                    }
                    <app-tennis-ranking [sportName]="sportName"></app-tennis-ranking>
                </div>
                <!-- / Col Right -->
            </div>
        }
        @if (client.use('sportQuickNav')) {
            <aside class="nav-sports d-none d-xl-block">
                <nav class="nav flex-column bg-light">
                    <app-sport-navigation
                        type="aside"
                        [date]="paramDate"
                        [limit]="asideLimit"
                        [sportId]="sportId"
                    ></app-sport-navigation>
                    <a
                        class="nav-link nav-link--more text-uppercase text-reset"
                        [class.nav-link--more]="isAsideDefault()"
                        [class.nav-link--less]="!isAsideDefault()"
                        (click)="toggleAssideLimit()"
                    >
                        @if (isAsideDefault()) {
                            <span>{{ 'web.more' | translate }}</span>
                        }
                        @if (!isAsideDefault()) {
                            <span>{{ 'web.less' | translate }}</span>
                        }
                    </a>
                </nav>
            </aside>
        }
        <aside [class.d-xl-block]="client.use('sportQuickNav')" class="nav-sports nav-sports--extra d-none">
            <nav class="nav flex-column nav-side-menu bg-light">
                <app-side-menu-navigation [sportId]="sportId" [sportName]="sportName"></app-side-menu-navigation>
            </nav>
        </aside>
    } @else {
        <div class="row">
            <!-- Col Left -->
            <div class="col-lg-8 bg-white pl-0 pr-0" [ngClass]="parentClass">
                <app-placeholder-tournament></app-placeholder-tournament>
            </div>
            <div class="col-lg-4 p-3 d-none d-lg-block" [ngClass]="matchClass">
                <app-placeholder-detail></app-placeholder-detail>
            </div>
        </div>
    }
</div>
